module.exports = __webpack_public_path__ + "static/media/test2_1.68a7e840.png";